import { createWidgetEndpoint, useSettingsContext, useField } from '@retailcrm/embed-ui';
import { fromInsideIframe } from '@remote-ui/rpc';
import { createI18n } from 'vue-i18n';
import { watch } from 'vue';
import AiOrderText from './AiOrderText.vue';
const messages = {
    'ru-RU': {
        button: 'Загрузить данные заказа',
        title: 'Создание заказа',
        titleEdit: 'Изменение заказа',
        label: 'Опишите заказ в свободной форме',
        analyze: 'Создать заказ',
        analyzeEdit: 'Изменить заказ',
        cancel: 'Отмена',
        openOrder: 'Открыть созданный заказ',
        loading: 'Обработка…',
        errorTitle: 'Ошибка',
        help: {
            ariaLabel: 'Подсказка',
            title: 'Как подготовить текст',
            intro: 'Можно вставить полный текст заказа или его часть — из письма, чата или файла.',
            list: {
                contacts: 'Контакты клиента: имя, телефон, email',
                company: 'Реквизиты компании (если есть)',
                items: 'Товары/услуги: наименование, количество, цена',
                address: 'Адрес доставки и комментарии',
            },
            footer: 'Система распознаёт данные и заполнит поля заказа автоматически.',
        },
        placeholder: `Вставьте сюда текст заказа или сообщение клиента (можно из письма/чата).

Пример: 
Иван Петров, +7 900 000-00-00, ivan__AT__test.ru
ООО «Ромашка», ИНН 9715243321
Реквизиты компании...........
Расчётный счёт 40702810902310002321
Наименование банка АО «АЛЬФА-БАНК» г.
Москва Банковские реквизиты: .......
Товары: Светильник A — 3 шт по 1 200; Штатив B — 1 шт по 5 900
Доставка: Санкт-Петербург, Лиговский пр., 10, офис 5
Комментарий: доставить до 18:00 во вторник`,
        fillOnlyToggle: 'Заполнить поля формы заказа без сохранения',
        enterTextError: 'Введите текст',
        itemsTitle: 'Распознанные товары',
        loadItems: 'Загрузить в заказ',
        applyHint: 'При загрузке изменения будут сохранены.',
        applyNoChanges: 'Нет данных для загрузки.',
        pendingTitle: 'Данные, которые не удалось подставить',
        pendingColumnField: 'Поле',
        pendingColumnValue: 'Значение',
        pendingItemLabel: 'Товар {index}',
        pendingField: {
            customerComment: 'Комментарий клиента',
            email: 'Email',
            phone: 'Телефон',
            firstName: 'Имя',
            lastName: 'Фамилия',
            patronymic: 'Отчество',
            deliveryAddress: 'Адрес доставки',
            customerType: 'Тип клиента',
            customerPhone: 'Телефон (контакт)',
            contragentType: 'Тип контрагента',
            legalName: 'Название компании',
            legalAddress: 'Юр. адрес',
            INN: 'ИНН',
            KPP: 'КПП',
            OGRN: 'ОГРН',
            BIK: 'БИК',
            bank: 'Банк',
            bankAddress: 'Адрес банка / город',
            corrAccount: 'Корр. счёт',
            bankAccount: 'Расчётный счёт',
        },
        fillOnlyHint: 'Внимание! Данные будут подставлены в поля формы без сохранения.',
        fillOnlyAppliedNote: 'Данные подставлены в форму. Проверьте изменения и сохраните заказ стандартной кнопкой или загрузите товары.',
        fillOnlyNoChanges: 'Новых данных для подстановки нет.',
        helpTip: 'Вставьте полный текст заказа или любую его часть — контактные данные клиента, реквизиты, перечень товаров с ценами и количеством, адрес доставки и комментарии. Модуль сам определит нужные поля и загрузит заказ в CRM. Нажмите «Загрузить», чтобы начать.',
    },
    'en-GB': {
        button: 'Upload order data',
        title: 'Create order from text',
        titleEdit: 'Edit order from text',
        label: 'Describe the order in free form',
        analyze: 'Create order',
        analyzeEdit: 'Update order',
        cancel: 'Cancel',
        openOrder: 'Open the created order',
        loading: 'Processing…',
        errorTitle: 'Error',
        help: {
            ariaLabel: 'Help',
            title: 'How to prepare the text',
            intro: 'You can paste the full order text or any part of it — from an email, chat or a file.',
            list: {
                contacts: 'Customer contacts: name, phone, email',
                company: 'Company details (if any)',
                items: 'Products/services: name, quantity, price',
                address: 'Delivery address and comments',
            },
            footer: 'The system will recognize the data and fill the order fields automatically.',
        },
        placeholder: `Paste the order text or the customer's message here (from an email/chat is fine).

Example:
Ivan Petrov, +7 900 000-00-00, ivan__AT__mail.ru
LLC "Romashka", TIN 9715243321 Company details...........
Checking account 40702810902310002321
Bank name JSC "ALFA-BANK", Moscow Banking details: .......
Products: Lamp A — 3 pcs at 1,200; Tripod B — 1 pc at 5,900
Delivery: Saint Petersburg, Ligovsky Ave., 10, office 5
Comment: deliver by 18:00 on Tuesday`,
        fillOnlyToggle: 'Fill fields without saving',
        enterTextError: 'Enter text',
        itemsTitle: 'Recognised products',
        loadItems: 'Load into the order',
        applyHint: 'Changes will be saved when you load them.',
        applyNoChanges: 'No data to load.',
        pendingTitle: 'Data that could not be auto-filled',
        pendingColumnField: 'Field',
        pendingColumnValue: 'Value',
        pendingItemLabel: 'Item {index}',
        pendingField: {
            customerComment: 'Customer comment',
            email: 'Email',
            phone: 'Phone',
            firstName: 'First name',
            lastName: 'Last name',
            patronymic: 'Middle name',
            deliveryAddress: 'Delivery address',
            customerType: 'Customer type',
            customerPhone: 'Phone (contact)',
            contragentType: 'Counterparty type',
            legalName: 'Company name',
            legalAddress: 'Registered address',
            INN: 'INN',
            KPP: 'KPP',
            OGRN: 'OGRN',
            BIK: 'BIC',
            bank: 'Bank',
            bankAddress: 'Bank address / city',
            corrAccount: 'Correspondent account',
            bankAccount: 'Checking account',
        },
        fillOnlyHint: 'Data will be inserted into the form without saving.',
        fillOnlyAppliedNote: 'Data have been inserted into the form. Review the changes and save the order with the standard button, or load the products.',
        fillOnlyNoChanges: 'No new data to insert.',
        helpTip: 'Paste the full order text or any part of it — customer contacts, company details, list of products with prices and quantities, delivery address and comments. The module will detect the required fields and load the order into the CRM. Click “Upload” to start.',
    },
    'es-ES': {
        button: 'Cargar datos del pedido',
        title: 'Creación de pedido a partir de texto',
        titleEdit: 'Edición de pedido a partir de texto',
        label: 'Describa el pedido en forma libre',
        analyze: 'Crear pedido',
        analyzeEdit: 'Actualizar pedido',
        cancel: 'Cancelar',
        openOrder: 'Abrir el pedido creado',
        loading: 'Procesando…',
        errorTitle: 'Error',
        help: {
            ariaLabel: 'Ayuda',
            title: 'Cómo preparar el texto',
            intro: 'Puede pegar el texto completo del pedido o una parte — de un correo, chat o archivo.',
            list: {
                contacts: 'Contactos del cliente: nombre, teléfono, correo',
                company: 'Datos de la empresa (si los hay)',
                items: 'Productos/servicios: nombre, cantidad, precio',
                address: 'Dirección de entrega y comentarios',
            },
            footer: 'El sistema reconocerá los datos y completará los campos del pedido automáticamente.',
        },
        placeholder: `Pegue aquí el texto del pedido o el mensaje del cliente (puede ser de un correo/chat).

Ejemplo:
Iván Petrov, +7 900 000-00-00, ivan__AT__mail.ru
OOO «Romashka», INN 9715243321
Datos de la empresa...........
Cuenta corriente
40702810902310002321
Nombre del banco
SA «ALFA-BANK», Moscú
Datos bancarios: .......
Productos: Lámpara A — 3 uds a 1.200; Trípode B — 1 ud a 5.900
Entrega: San Petersburgo, Av. Ligovski, 10, oficina 5
Comentario: entregar antes de las 18:00 del martes`,
        fillOnlyToggle: 'Rellenar los campos sin guardar',
        enterTextError: 'Introduzca el texto',
        itemsTitle: 'Productos reconocidos',
        loadItems: 'Cargar al pedido',
        applyHint: 'Al cargar, los cambios se guardarán.',
        applyNoChanges: 'No hay datos para cargar.',
        pendingTitle: 'Datos que no se pudieron rellenar automáticamente',
        pendingColumnField: 'Campo',
        pendingColumnValue: 'Valor',
        pendingItemLabel: 'Producto {index}',
        pendingField: {
            customerComment: 'Comentario del cliente',
            email: 'Correo electrónico',
            phone: 'Teléfono',
            firstName: 'Nombre',
            lastName: 'Apellido',
            patronymic: 'Segundo nombre',
            deliveryAddress: 'Dirección de entrega',
            customerType: 'Tipo de cliente',
            customerPhone: 'Teléfono (contacto)',
            contragentType: 'Tipo de contraparte',
            legalName: 'Nombre de la empresa',
            legalAddress: 'Dirección jurídica',
            INN: 'INN',
            KPP: 'KPP',
            OGRN: 'OGRN',
            BIK: 'BIC',
            bank: 'Banco',
            bankAddress: 'Dirección del banco / ciudad',
            corrAccount: 'Cuenta corresponsal',
            bankAccount: 'Cuenta corriente',
        },
        fillOnlyHint: 'Los datos se insertarán en el formulario sin guardar.',
        fillOnlyAppliedNote: 'Los datos se han insertado en el formulario. Revise los cambios y guarde el pedido con el botón estándar o cargue los productos.',
        fillOnlyNoChanges: 'No hay datos nuevos para aplicar.',
        helpTip: 'Pegue el texto completo del pedido o cualquier parte: datos de contacto del cliente, datos de la empresa, lista de productos con precios y cantidades, dirección de entrega y comentarios. El módulo detectará los campos necesarios y cargará el pedido en el CRM. Haga clic en «Cargar» para empezar.',
    },
};
const LOCALES = Object.keys(messages);
// Поддержка разных вариантов локали из аккаунта (ru, ru_RU, en, en_US, es, es_ES)
const MAP = {
    ru: 'ru-RU', 'ru_RU': 'ru-RU',
    en: 'en-GB', 'en_GB': 'en-GB', 'en_US': 'en-GB',
    es: 'es-ES', 'es_ES': 'es-ES',
};
const normalizeLocale = (loc) => {
    if (!loc)
        return 'en-GB';
    if (LOCALES.includes(loc))
        return loc;
    const mapped = MAP[loc];
    return mapped ?? 'en-GB';
};
createWidgetEndpoint({
    async run(createVueApp, root, pinia, target) {
        const i18n = createI18n({
            legacy: false,
            fallbackLocale: 'en-GB',
            locale: 'en-GB',
            messages,
        });
        const app = createVueApp(AiOrderText, { target });
        app.use(pinia);
        app.use(i18n);
        const settings = useSettingsContext();
        const localeField = useField(settings, 'system.locale');
        settings.initialize();
        watch(localeField, (loc) => { i18n.global.locale.value = normalizeLocale(loc); }, { immediate: true });
        app.mount(root);
        return () => app.unmount();
    },
}, fromInsideIframe());
